import CustomSnackbar from "@/components/navigation/CustomSnackbar"
import LoggedOutStructure from "@/components/navigation/LoggedOutStructure"
import PrivateRoute from "@/components/navigation/utils/PrivateRoute"
import {
  AUTH_PATTERN,
  DONATE_PATTERN,
} from "@/components/navigation/publicRoutePatterns"
import GetLoadable from "@/components/utils/GetLoadable"
import Toaster from "@/components/utils/toast/Toaster"
import { useCustomer, useIsLoggedIn } from "@/hooks/reduxHooks"
import { useAppSelector } from "@/store/store"
import LoadingWavelengthRadio from "icons/LoadingWavelengthRadio"
import { lazy, memo } from "react"
import { useLocation } from "react-router-dom"

const LoadableLoggedInApp = GetLoadable(
  lazy(() => import("components/navigation/LoggedInApp")),
  <div />,
)
const LoadableStandaloneDonate = GetLoadable(
  lazy(() => import("components/donations/StandaloneDonate")),
  <LoadingWavelengthRadio />,
)

const LoggedInOutRoutesSwitch = memo(() => {
  const location = useLocation()
  const customer = useCustomer()
  const fetchingState = useAppSelector(({ access }) => access.user.fetchingState)
  const loggedIn = useIsLoggedIn()

  if (fetchingState) {
    return <LoadingWavelengthRadio />
  }

  const isAuthPath = AUTH_PATTERN.test(location.pathname)
  const isDonate = DONATE_PATTERN.test(location.pathname)
  const showStandaloneDonate =
    !customer.hideInternalDonations && !customer.isRoot && !loggedIn && isDonate

  return (
    <div id="loggedInRoutes" className="flex-center-column grow">
      {showStandaloneDonate ? (
        <LoadableStandaloneDonate customer={customer} loggedIn={loggedIn} />
      ) : isAuthPath ? (
        <LoggedOutStructure />
      ) : (
        <PrivateRoute component={LoadableLoggedInApp} />
      )}

      <CustomSnackbar />
      <Toaster />
    </div>
  )
})

export default LoggedInOutRoutesSwitch
